import type { svg } from "../../../Icon/img"

/**
 * Tracked in guide progress via the shared `completedLessonIds` list (see
 * useGuideProgress) — the story isn't a GUIDE_LESSONS entry, but reuses the
 * same progress mechanism rather than adding a parallel one.
 */
export const PRODUCT_STORY_ID = "product-story-what-is-ezbuild"

export interface StoryWorkflowStage {
  id: string
  titleKey: string
  descriptionKey: string
}

// LEAD → SCOPE → ESTIMATE → PROPOSAL → CONTRACT → PROJECT → PLAN → BUILD → COMPLETE
export const STORY_WORKFLOW_STAGES: StoryWorkflowStage[] = [
  {
    id: "lead",
    titleKey: "guide.story.workflow.lead.title",
    descriptionKey: "guide.story.workflow.lead.description"
  },
  {
    id: "scope",
    titleKey: "guide.story.workflow.scope.title",
    descriptionKey: "guide.story.workflow.scope.description"
  },
  {
    id: "estimate",
    titleKey: "guide.story.workflow.estimate.title",
    descriptionKey: "guide.story.workflow.estimate.description"
  },
  {
    id: "proposal",
    titleKey: "guide.story.workflow.proposal.title",
    descriptionKey: "guide.story.workflow.proposal.description"
  },
  {
    id: "contract",
    titleKey: "guide.story.workflow.contract.title",
    descriptionKey: "guide.story.workflow.contract.description"
  },
  {
    id: "project",
    titleKey: "guide.story.workflow.project.title",
    descriptionKey: "guide.story.workflow.project.description"
  },
  {
    id: "plan",
    titleKey: "guide.story.workflow.plan.title",
    descriptionKey: "guide.story.workflow.plan.description"
  },
  {
    id: "build",
    titleKey: "guide.story.workflow.build.title",
    descriptionKey: "guide.story.workflow.build.description"
  },
  {
    id: "complete",
    titleKey: "guide.story.workflow.complete.title",
    descriptionKey: "guide.story.workflow.complete.description"
  }
]

export interface StoryBigPictureCategory {
  id: string
  titleKey: string
  icon: keyof typeof svg
  /** Resolves via t(itemsKey, { returnObjects: true }) to a string[]. */
  itemsKey: string
}

export const STORY_BIG_PICTURE_CATEGORIES: StoryBigPictureCategory[] = [
  {
    id: "sales",
    titleKey: "guide.story.bigPicture.sales.title",
    icon: "Leads",
    itemsKey: "guide.story.bigPicture.sales.items"
  },
  {
    id: "operations",
    titleKey: "guide.story.bigPicture.operations.title",
    icon: "Projects",
    itemsKey: "guide.story.bigPicture.operations.items"
  },
  {
    id: "finance",
    titleKey: "guide.story.bigPicture.finance.title",
    icon: "Dollar",
    itemsKey: "guide.story.bigPicture.finance.items"
  },
  {
    id: "people",
    titleKey: "guide.story.bigPicture.people.title",
    icon: "Users",
    itemsKey: "guide.story.bigPicture.people.items"
  },
  {
    id: "documents",
    titleKey: "guide.story.bigPicture.documents.title",
    icon: "Upload",
    itemsKey: "guide.story.bigPicture.documents.items"
  },
  {
    id: "communication",
    titleKey: "guide.story.bigPicture.communication.title",
    icon: "Bell",
    itemsKey: "guide.story.bigPicture.communication.items"
  }
]

export interface StoryPillar {
  id: string
  titleKey: string
  flowKey: string
  descriptionKey: string
  icon: keyof typeof svg
}

export const STORY_PILLARS: StoryPillar[] = [
  {
    id: "sales",
    titleKey: "guide.story.pillars.sales.title",
    flowKey: "guide.story.pillars.sales.flow",
    descriptionKey: "guide.story.pillars.sales.description",
    icon: "Leads"
  },
  {
    id: "projects",
    titleKey: "guide.story.pillars.projects.title",
    flowKey: "guide.story.pillars.projects.flow",
    descriptionKey: "guide.story.pillars.projects.description",
    icon: "Projects"
  },
  {
    id: "finance",
    titleKey: "guide.story.pillars.finance.title",
    flowKey: "guide.story.pillars.finance.flow",
    descriptionKey: "guide.story.pillars.finance.description",
    icon: "Dollar"
  },
  {
    id: "people",
    titleKey: "guide.story.pillars.people.title",
    flowKey: "guide.story.pillars.people.flow",
    descriptionKey: "guide.story.pillars.people.description",
    icon: "Users"
  },
  {
    id: "documents",
    titleKey: "guide.story.pillars.documents.title",
    flowKey: "guide.story.pillars.documents.flow",
    descriptionKey: "guide.story.pillars.documents.description",
    icon: "Upload"
  },
  {
    id: "communication",
    titleKey: "guide.story.pillars.communication.title",
    flowKey: "guide.story.pillars.communication.flow",
    descriptionKey: "guide.story.pillars.communication.description",
    icon: "Bell"
  }
]
